import { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../../firebase';

/**
 * Fetches city list from /cities DB node.
 * Returns { cities, loading } where cities is an array of { name, country, shopCount, imageUrl }
 */
export default function useCities() {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const citiesRef = ref(database, 'cities');
    const unsubscribe = onValue(citiesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.values(data).sort((a, b) => (b.shopCount || 0) - (a.shopCount || 0));
        setCities(list);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  return { cities, loading };
}
